import { set } from '@/utils/vuex';

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  setColorHexLight: set('colorHexLight'),
  setColorHexDark: set('colorHexDark'),
  setLoad: set('load'),
  setMode: set('mode'),
  setMapStyle: set('mapStyle'),
  setVdListCols: set('vd_list_cols'),
  setThingshiveMap3DBuild: set('thingshiveMap3DBuild'),
  setThingshiveColorLight: set('thingshiveColorLight'),
  setThingshiveColorDark: set('thingshiveColorDark'),
  setTileSize: set('tileSize'),
  setThingshiveTheme: set('thingshiveTheme'),
  setThingshiveImage: set('thingshiveImage'),
  setIsWarnAppDTwinId: set('is-warnapp-dtwin-id'),
  setLoading: set('loading'),
  setSnackbar: set('snackbar'),
  setUiTheme: set('UiTheme'),
  setMiniVariant: set('miniVariant'),
  setMap3DBuild: set('map3DBuild'),
  setInfoSnack: set('infoSnack'),
  setBannerHeight: set('bannerHeight'),
  setRefreshGMMinutes: set('refreshGMMinutes'),
  setRowsPerPage: set('rowsPerPage'),
  setSmartGroupsPerPage: set('smartGroupsPerPage'),
  setTablePage: set('tablePage'),
  setDtwinStateConfigCopy: set('dtwinStateConfigCopy'),
  openedTreeview: set('openedTreeview'),
  setFeedbackEmail: set('feedbackEmail'),
  setFeatureFlags: set('featureFlags'),
  setAssistantOpen: set('assistantOpen'),
  setAssistantTasksCollapsed: set('assistantTasksCollapsed'),
  setField(state, { field, value }) {
    state[field] = value;
  },
  language(state, { payload, context }) {
    // const langPrefix = payload === 'de' ? '' : `/${payload}`;
    const langPrefix = `/${payload}`;
    state.docsBaseURL = `${state.docsDomain}${langPrefix}/`;
    state.releaseNotesURL = `${state.docsDomain}${langPrefix}/changelog/`;
    state.language = payload;
    if (context) {
      context.$root.$i18n.locale = payload;
      context.$i18n.locale = payload;
      context.$root._i18n._vm.locale = payload;
    }
  },
  useAltFonts(state, { payload }) {
    state.useAltFonts = payload;
  },
  app_permissions(state, { permissions }) {
    state.permissions = permissions;
  },
  n2AccountsInvalidateCache(state) {
    state.n2Accounts = {
      ...state.n2Accounts,
      lastFetched: null,
    };
  },
  n2Accounts(state, { accounts, selectedIds }) {
    state.n2Accounts = {
      lastFetched: new Date().toISOString(),
      accounts: accounts || state.n2Accounts.accounts,
      selectedIds: selectedIds || state.n2Accounts.selectedIds,
    };
  },
  n1AccountsInvalidateCache(state) {
    state.n1Accounts = {
      ...state.n1Accounts,
      lastFetched: null,
    };
  },
  n1Accounts(state, { accounts, selectedIds }) {
    state.n2Accounts = {
      lastFetched: new Date().toISOString(),
      accounts: accounts || state.n2Accounts.accounts,
      selectedIds: selectedIds || state.n2Accounts.selectedIds,
    };
  },
  virtualDeviceListSearch(state, { items, operator }) {
    state.pageFilters.VirtualDevice.list.searchDetails = Array.isArray(items) ? [...items] : items;
    state.pageFilters.VirtualDevice.list.searchOperator = operator;
  },
};
